module.exports = __webpack_public_path__ + "static/media/Terrick Road Alcove Units (8).be7a9933.jpg";